import {
  GETAPI_SUCCESS,
  GETROUTE_SUCCESS,
  GETROUTE_CATEGORY_SUCCESS
} from '../types';

const initialState = {
  routeData: [],
  routeCategoryData: []
};

export default function RouteManagerReducer(state = initialState, action) {
  switch (action.type) {
    case GETROUTE_SUCCESS:
      return {
        ...state,
        routeData: action.payload
      };
    case GETROUTE_CATEGORY_SUCCESS:
      return {
        ...state,
        routeCategoryData: action.payload.data
      };
    default:
      return state;
  }
}
